export default __webpack_public_path__ + "static/media/nutrition.483306f4.svg";